import React from "react";

const InventoryQueues = () => <div className="content"><h2>Queues</h2></div>;

export default InventoryQueues; 